/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddOrRemoveDocumentToEventDto } from '../models/work-add-or-remove-document-to-event-dto';
import { WorkCreateEventDto } from '../models/work-create-event-dto';
import { WorkDocument } from '../models/work-document';
import { WorkEvent } from '../models/work-event';
import { WorkEventInvitation } from '../models/work-event-invitation';
import { WorkEventReadConfirmationsDto } from '../models/work-event-read-confirmations-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateEventDto } from '../models/work-update-event-dto';

@Injectable({ providedIn: 'root' })
export class WorkEventsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventsV2ControllerFindAllPaginated()` */
  static readonly EventsV2ControllerFindAllPaginatedPath = '/v2/events';

  /**
   * Required permissions: events:read, events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by endAt query param.
     *           <p>
     *              <b>Format: </b> filter.endAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.endAt=$not:$like:John Doe&filter.endAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gt</li>
     * <li>$lt</li></ul>
     */
      'filter.endAt'?: Array<string>;

    /**
     * Filter by eventInvitations.userId query param.
     *           <p>
     *              <b>Format: </b> filter.eventInvitations.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.eventInvitations.userId=$not:$like:John Doe&filter.eventInvitations.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.eventInvitations.userId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> startAt:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>title</li>
     * <li>startAt</li>
     * <li>organizer.firstName</li></ul>
     */
      sortBy?: Array<'title:ASC' | 'title:DESC' | 'startAt:ASC' | 'startAt:DESC' | 'organizer.firstName:ASC' | 'organizer.firstName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title,organizer.firstName,organizer.lastName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li>
     * <li>organizer.firstName</li>
     * <li>organizer.lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEvent>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'endAt'?: (string | Array<string>);
'eventInvitations.userId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.endAt', params['filter.endAt'], {});
      rb.query('filter.eventInvitations.userId', params['filter.eventInvitations.userId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkEvent>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'endAt'?: (string | Array<string>);
        'eventInvitations.userId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: events:read, events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by endAt query param.
     *           <p>
     *              <b>Format: </b> filter.endAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.endAt=$not:$like:John Doe&filter.endAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gt</li>
     * <li>$lt</li></ul>
     */
      'filter.endAt'?: Array<string>;

    /**
     * Filter by eventInvitations.userId query param.
     *           <p>
     *              <b>Format: </b> filter.eventInvitations.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.eventInvitations.userId=$not:$like:John Doe&filter.eventInvitations.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.eventInvitations.userId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> startAt:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>title</li>
     * <li>startAt</li>
     * <li>organizer.firstName</li></ul>
     */
      sortBy?: Array<'title:ASC' | 'title:DESC' | 'startAt:ASC' | 'startAt:DESC' | 'organizer.firstName:ASC' | 'organizer.firstName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title,organizer.firstName,organizer.lastName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li>
     * <li>organizer.firstName</li>
     * <li>organizer.lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkEvent>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'endAt'?: (string | Array<string>);
'eventInvitations.userId'?: (string | Array<string>);
};
};
}> {
    return this.eventsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEvent>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'endAt'?: (string | Array<string>);
'eventInvitations.userId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkEvent>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'endAt'?: (string | Array<string>);
'eventInvitations.userId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `eventsV2ControllerCreate()` */
  static readonly EventsV2ControllerCreatePath = '/v2/events';

  /**
   * Required permissions: events:create, events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV2ControllerCreate$Response(
    params: {
      body: WorkCreateEventDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEvent>;
      })
    );
  }

  /**
   * Required permissions: events:create, events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV2ControllerCreate(
    params: {
      body: WorkCreateEventDto
    },
    context?: HttpContext
  ): Observable<WorkEvent> {
    return this.eventsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEvent>): WorkEvent => r.body)
    );
  }

  /** Path part for operation `eventsV2ControllerFindOneById()` */
  static readonly EventsV2ControllerFindOneByIdPath = '/v2/events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEvent>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEvent> {
    return this.eventsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEvent>): WorkEvent => r.body)
    );
  }

  /** Path part for operation `eventsV2ControllerDelete()` */
  static readonly EventsV2ControllerDeletePath = '/v2/events/{id}';

  /**
   * Required permissions: events:delete, events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: events:delete, events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventsV2ControllerUpdate()` */
  static readonly EventsV2ControllerUpdatePath = '/v2/events/{id}';

  /**
   * Required permissions: events:update, events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateEventDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEvent>;
      })
    );
  }

  /**
   * Required permissions: events:update, events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateEventDto
    },
    context?: HttpContext
  ): Observable<WorkEvent> {
    return this.eventsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEvent>): WorkEvent => r.body)
    );
  }

  /** Path part for operation `eventsV2ControllerGetDocumentsByEventId()` */
  static readonly EventsV2ControllerGetDocumentsByEventIdPath = '/v2/events/{id}/documents';

  /**
   * Required permissions: events:read, events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerGetDocumentsByEventId()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerGetDocumentsByEventId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerGetDocumentsByEventIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: events:read, events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerGetDocumentsByEventId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerGetDocumentsByEventId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.eventsV2ControllerGetDocumentsByEventId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `eventsV2ControllerAddDocumentToEvent()` */
  static readonly EventsV2ControllerAddDocumentToEventPath = '/v2/events/{id}/documents';

  /**
   * Required permissions: events:update, events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerAddDocumentToEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV2ControllerAddDocumentToEvent$Response(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToEventDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerAddDocumentToEventPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEvent>;
      })
    );
  }

  /**
   * Required permissions: events:update, events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerAddDocumentToEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV2ControllerAddDocumentToEvent(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToEventDto
    },
    context?: HttpContext
  ): Observable<WorkEvent> {
    return this.eventsV2ControllerAddDocumentToEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEvent>): WorkEvent => r.body)
    );
  }

  /** Path part for operation `eventsV2ControllerRemoveDocumentFromEvent()` */
  static readonly EventsV2ControllerRemoveDocumentFromEventPath = '/v2/events/{id}/documents/{documentId}';

  /**
   * Required permissions: events:update, events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerRemoveDocumentFromEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV2ControllerRemoveDocumentFromEvent$Response(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToEventDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerRemoveDocumentFromEventPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: events:update, events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerRemoveDocumentFromEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsV2ControllerRemoveDocumentFromEvent(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToEventDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.eventsV2ControllerRemoveDocumentFromEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `eventsV2ControllerMarkAsRead()` */
  static readonly EventsV2ControllerMarkAsReadPath = '/v2/events/{id}/read';

  /**
   * Required permissions: events:read, events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerMarkAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerMarkAsRead$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventInvitation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerMarkAsReadPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventInvitation>;
      })
    );
  }

  /**
   * Required permissions: events:read, events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerMarkAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerMarkAsRead(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEventInvitation> {
    return this.eventsV2ControllerMarkAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventInvitation>): WorkEventInvitation => r.body)
    );
  }

  /** Path part for operation `eventsV2ControllerConfirmRead()` */
  static readonly EventsV2ControllerConfirmReadPath = '/v2/events/{id}/read-confirmation';

  /**
   * Required permissions: events:read, events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerConfirmRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerConfirmRead$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventInvitation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerConfirmReadPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventInvitation>;
      })
    );
  }

  /**
   * Required permissions: events:read, events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerConfirmRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerConfirmRead(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEventInvitation> {
    return this.eventsV2ControllerConfirmRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventInvitation>): WorkEventInvitation => r.body)
    );
  }

  /** Path part for operation `eventsV2ControllerFindReadConfirmations()` */
  static readonly EventsV2ControllerFindReadConfirmationsPath = '/v2/events/{id}/read-confirmations';

  /**
   * Required permissions: events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsV2ControllerFindReadConfirmations()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerFindReadConfirmations$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventReadConfirmationsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventsV2Service.EventsV2ControllerFindReadConfirmationsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventReadConfirmationsDto>;
      })
    );
  }

  /**
   * Required permissions: events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsV2ControllerFindReadConfirmations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsV2ControllerFindReadConfirmations(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEventReadConfirmationsDto> {
    return this.eventsV2ControllerFindReadConfirmations$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventReadConfirmationsDto>): WorkEventReadConfirmationsDto => r.body)
    );
  }

}
